"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Card = {
    baseStyle: {
        container: {
            overflow: 'hidden',
            borderColor: '#ECEDEF',
            borderWidth: '1px',
            bg: 'chakra-body-bg',
            borderRadius: '16px',
        },
    },
};
exports.default = Card;
